export const environment = {
  production: false,
  api: 'https://api-arcade-dev.sibillc.xyz',
  uiUrl: 'https://arcade-dev.sibillc.xyz',
  cognitoClientId: 'sip37n6f41hmd1fmesonrck9b',
  authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_lzcp6VacY',
  cognitoDomain: 'https://us-east-1lzcp6vacy.auth.us-east-1.amazoncognito.com',
};
